import * as THREE from 'three';

import { ThreeJSClass } from '@threeJS/threejs.helper';

import Simulator from '../simulator';

export default class Renderer extends ThreeJSClass {
  _renderer: THREE.WebGLRenderer;

  constructor(simulation: Simulator) {
    super(simulation);
    this._renderer = this._addRenderer();
  }

  _addRenderer() {
    const renderer = new THREE.WebGLRenderer({
      canvas: this._simulation.canvas,
      alpha: true,
      antialias: true,
    });
    renderer.shadowMap.enabled = false;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.setSize(
      this._simulation._sizes.width,
      this._simulation._sizes.height
    );
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    return renderer;
  }

  onTick(elapsedTime: number): void {
    // this._renderer.setSize(window.innerWidth, window.innerHeight);
    this._renderer.render(this._simulation.scene, this._simulation.camera);
  }

  onToggleTheme(isDarkMode: boolean): void {}
  onToggleDebug(isDebug: boolean): void {}
  dispose(): void {
    // this._renderer.dispose;
  }
}
